module.exports = __webpack_public_path__ + "static/media/figure1.b8629596.png";